module.exports = __webpack_public_path__ + "img/glued-glossy-cover.2368909f.png";